import { render, staticRenderFns } from "./GetProcessesDetails.vue?vue&type=template&id=47fa1df6"
import script from "./GetProcessesDetails.vue?vue&type=script&lang=js"
export * from "./GetProcessesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports